import type React from "react";

import {
  InputOTP as ShadcnInputOTP,
  InputOTPGroup as ShadcnInputOTPGroup,
  InputOTPSlot as ShadcnInputOTPSlot,
  InputOTPSeparator as ShadcnInputOTPSeparator,
} from "src/shadcn/components/input-otp";

const InputOTP = (props: React.ComponentProps<typeof ShadcnInputOTP>) => (
  <ShadcnInputOTP {...props} />
);

const InputOTPGroup = (
  props: React.ComponentProps<typeof ShadcnInputOTPGroup>
) => <ShadcnInputOTPGroup {...props} />;

const InputOTPSlot = (
  props: React.ComponentProps<typeof ShadcnInputOTPSlot>
) => <ShadcnInputOTPSlot {...props} />;

const InputOTPSeparator = (
  props: React.ComponentProps<typeof ShadcnInputOTPSeparator>
) => <ShadcnInputOTPSeparator {...props} />;

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };
